<template>
  <section
    :class="[
      'app-main',
      {
        'is-in-fullpage': isFullPage,
      },
    ]"
  >
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppMain',
  computed: {
    ...mapState('app', ['isFullPage']),
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped lang="scss">
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: 20px;
  // overflow-x: scroll !important;
  overflow-x: auto !important;
  &.is-in-fullpage {
    padding: 0;
  }
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
